import { CreateNewProjectThemeSizeConfig } from './types';

const medium: CreateNewProjectThemeSizeConfig = {
  createNewProject: {},
};

export default medium;
